import css from "../../css/sitemap/sitemap.module.css";

import React from "react";
import PropTypes from "prop-types";

const States = (props) => {
    const { states } = props;

    return (
        <>
            <div className={css.subTitle}>
                <strong>US Real Estate</strong> Markets by State
            </div>

            <div className={css.columnWrapper}>
                {states.map((state) => (
                    <h2 key={state.id}>
                        <a
                            href={`/sitemap/${state.url}`}
                            className={css.menuItem}
                        >
                            {state.name} Real Estate
                        </a>
                    </h2>
                ))}
            </div>
        </>
    );
};

States.propTypes = {
    states: PropTypes.array.isRequired,
};

export default States;
